import { render, staticRenderFns } from "./SummaryStudyRecord.vue?vue&type=template&id=1154ed01&scoped=true"
import script from "./SummaryStudyRecord.vue?vue&type=script&lang=ts"
export * from "./SummaryStudyRecord.vue?vue&type=script&lang=ts"
import style0 from "./SummaryStudyRecord.vue?vue&type=style&index=0&id=1154ed01&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1154ed01",
  null
  
)

export default component.exports